import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismButton } from '@mylighthouse/prism-ember';
import dayjs from 'dayjs';
import type { Ota } from 'frontend-utils/models';
import generateOtaLink from 'frontend-utils/utils/url/generate-ota-link';

interface ParityTablesCellsTdPosLinkoutSignature {
  Args: {
    cellData: unknown;
  };
}

export default class ParityTablesCellsTdPosLinkout extends Component<ParityTablesCellsTdPosLinkoutSignature> {
  @service declare ajax: Services['ajax'];
  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];
  @service declare store: Services['store'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get day() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return this.period.day;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get hotel() {
    return this.hotelAndMarketService.hotel;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get linkoutURL() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
    const rowOtaId = this.period.parities[0].ota;

    if (rowOtaId) {
      // Check if this OTA has support for screenshots or not
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      const ota = this.store.peekRecord<Ota>('ota', rowOtaId);
      // @ts-expect-error: Incorrect type
      if (ota.hasScreenshots) {
        return `${this.ajax.host}/geoinsight/?subscriptionId=${
          this.hotel?.id
          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
        }&fromDate=${dayjs.utc(this.day.date).format('YYYY-MM-DD')}&toDate=${dayjs
          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
          .utc(this.day.date)
          .add(1, 'day')
          .format('YYYY-MM-DD')}`;
      }
    }

    return generateOtaLink(
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      rowOtaId,
      // @ts-expect-error: Incorrect type
      this.hotel?.hotelinfo?.id,
      this.hotel?.id,
      this.hotel?.isTripadvisorRebranding,
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
      (this.day?.periods ?? [])[0],
      this.hotel?.defaultPersons,
      'app_parity',
      '',
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      this.period.pos,
    );
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get period() {
    return this.args.cellData;
  }

  <template>
    <div class="flex items-center justify-end">
      <a
        data-event-id="parity-pos-table-geoinsight-redirect-link"
        href={{this.linkoutURL}}
        rel="noopener noreferrer"
        target="_blank"
      >
        <PrismButton @buttonType="secondary" @icon="view-live" @size="small" />
      </a>
    </div>
  </template>
}
